import { Component } from '@verndale/core';
import Swiper from 'swiper/core';
import { addGenericSwiperNav } from '../helpers/slider-nav';
import { isDevice } from '../helpers';
import _debounce from 'lodash.debounce';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $firstCard: this.el._$$('.promotional-card')[0],
      $cards: this.el._$$('.promotional-card'),
      $cardsContainer: this.el._$('.masthead__cards-container'),
      $pager: this.el._$('.slider-nav__pager'),
      $nav: this.el._$('.slider-nav'),
      $wrapper: this.el._$('.swiper-wrapper')
    }

    this.desktopNavNeeded = (this.dom.$firstCard.offsetWidth * this.dom.$cards.length) > this.dom.$cardsContainer.offsetWidth;

    this.initSlider();
    this.updateNavVisibility();
  }

  addListeners() {
    window._on('resize', _debounce(this.updateNavVisibility.bind(this), 200));
  }

  initSlider() {
    const { $cardsContainer, $cards, $nav } = this.dom;
    const slidesNumber = $cards.length;

    const swiper = new Swiper($cardsContainer, {
      spaceBetween: 30,
      slidesPerView: 'auto',
      ...addGenericSwiperNav(this.el)
    });

    if (slidesNumber === 1) {
      $cardsContainer.classList.add('centered-slides');
    }

    if (this.dom.$cards.length === 2) {
      this.dom.$wrapper.classList.add('swiper-wrapper--no-grow'); // don't distribute, just stack all cards to the right
    }

    $cardsContainer.style.visibility = 'visible';
  }

  updateNavVisibility() {
    const slidesNumber = this.dom.$cards.length;

    if (slidesNumber < 3) {
      if (slidesNumber === 1 || !isDevice()) {
        this.dom.$nav.style.display = 'none';
      } else {
        this.dom.$nav.style.display = 'flex';
      }
    } else if (this.dom.$nav.style.display !== 'flex') {
      this.dom.$nav.style.display = 'flex';
    }
  }
}

export default Module;
